export default "__VITE_ASSET__150eac61__"